export default {
  applicationDetail: {
    component: () =>
      import("@/mods/archive/dataApplication/detailView/DataApplicationDetail"),
  },
};
